export const FCL_EXPORT_BOOKING_REPORT_LIST = "FCL_EXPORT_BOOKING_REPORT_LIST";
export const FCL_EXPORT_BOOKING_REPORT_SUMMARY = "FCL_EXPORT_BOOKING_REPORT_SUMMARY";
export const FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS = "FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS";

export const FCL_EXPORT_SALESPERSON_REPORT_LIST = "FCL_EXPORT_SALESPERSON_REPORT_LIST";
export const FCL_EXPORT_SALESPERSON_REPORT_SUMMARY = "FCL_EXPORT_SALESPERSON_REPORT_SUMMARY";
export const FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS = "FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS";
export const FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS = "FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS";
export const FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST = "FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST";
